import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-video-tutorials',
  templateUrl: './video-tutorials.component.html',
  styleUrls: ['./video-tutorials.component.css']
})
export class VideoTutorialsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
